import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import {
    cancelRequest,
    confirmRequest,
    getAllCashlessPhysiotherapyRequests,
    downloadCsvReport,
    markConsultationCompleted,
} from '../../services/api/cashless-physiotherapy-v2';
import {
    OuterComponent,
    PaddedContainer,
} from '../customer-support/StyledComponent';
import NavBar from '../layout/NavBar';
import { ButtonGroup, Row, Button } from 'reactstrap';
import { SearchBox, SearchBoxContent, SearchBoxInput } from './styled-elements';
import { FaSearch } from 'react-icons/fa';
import useAfterInitialEffect from './hooks/useAfterInitialEffect';
import LoadingComponent from '../common/LoadingComponent';
import PhysiotherapyModalConfirm from './modals/PhysiotherapyModalConfirm';
import { toast } from 'react-toastify';
import PhysiotherapyModalCancel from './modals/PhysiotherapyModalCancel';
import PhysiotherapyCallModal from './modals/PhysiotherapyCallModal';
import { connect } from 'react-redux';
import {
    hidePhysiotherapyRequestModal,
    showPhysiotherapyRequestModal,
} from '../../actions';
// import PhysiotherapyRequestDetails from './modals/PhysiotherapyRequestDetails';
import useTableColumns from './hooks/useTableColumns';
import PhysiotherapyClaimModal from './modals/PhysiotherapyClaimModal';
import PhysiotherapyCommentModal from './modals/PhysiotherapyCommentModal';
import moment from 'moment';
import SubContainer from './components/SubContainer';
import PhysiotherapyShiftRequestModal from './modals/PhysiotherapyShiftRequestModal';
import PhysiotherapyRequestDetails from './modals/PhysiotherapyRequestDetails';
import PhysiotherapyUploadPrescriptionModal from './modals/PhysiotherapyUploadPrescriptionModal';
import PhysiotherapyRescheduleModal from './modals/PhysiotherapyRescheduleModal';

const initialDates = {
    startDate: null,
    endDate: null,
};
const defaultCallAlertData = {
    isOpen: false,
    header: '',
    body: '',
    onSubmit: null,
    requestId: null,
    onClose: null,
};

const CashlessPhysiotherapyV2 = ({
    dispatch,
    cashlessPhysiotherapy: stateDetails,
}) => {
    const { requestId: deeplinkRequestId } = useParams();
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);
    const [data, setData] = useState([]);
    const [makeSearch, setMakeSearch] = useState('');
    const [totalRecords, setTotalRecords] = useState(0);
    const [requestIdFilter, setRequestIdFilter] = useState('');
    const [parentIdFilter, setParentIdFilter] = useState('');
    const [centerFilter, setRequestCenterFilter] = useState('');
    const [sponsorFilter, setRequestSponsorFilter] = useState('');
    const [vaccinationFilter, setRequestPhysiotherapyFilter] = useState('');
    const [visitTypeFilter, setVisitTypeFilter] = useState('');
    const [statusFilter, setStatusFilter] = useState('');
    const [stageFilter, setStageFilter] = useState('');
    const [appointmentDateFilter, setAppointmentDateFilter] = useState(null);
    const [requestDateFilter, setRequestDateFilter] = useState(null);
    const [appTimeFilter, setAppTimeFilter] = useState(['', '']);
    const [pages, setPages] = useState(0);
    const [pageSize, setPageSize] = useState(20);
    const [currentPage, setCurrentPage] = useState(0);
    const [requestId, setRequestId] = useState(null);
    const [requestedAppointmentDate, setRequestedAppointmentDate] =
        useState(null);
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const [cancelModalIsOpen, setCancelModalIsOpen] = useState(false);
    const [callAlertData, setCallAlertData] = useState(defaultCallAlertData);
    const [ackFilter, setAckFilter] = useState('');
    const [showClaimModal, setShowClaimModal] = useState(false);
    const [claimRequestId, setClaimRequestId] = useState(null);
    const [showEditPayment, setShowEditPayment] = useState(false);
    const [editPaymentRequestId, setEditPaymentRequestId] = useState(null);
    const [showShiftRequest, setShowShiftRequest] = useState(false);
    const [shiftRequestId, setShiftRequestId] = useState(null);
    const [showCommentModal, setShowCommentModal] = useState(false);
    const [commentModalRequestId, setCommentModalRequestId] = useState(null);
    const [showUploadPrescriptionModal, setShowUploadPrescriptionModal] = useState(false);
    const [uploadPrescriptionRequestId, setUploadPrescriptionRequestId] = useState(null);
    const [showRescheduleModal, setShowRescheduleModal] = useState(false);
    const [rescheduleRequestId, setRescheduleRequestId] = useState(null);
    const [tagsFilter, setTagsFilter] = useState('');
    const [requestModalOpen, setRequestModalOpen] = useState(false);
    const [toggleActions, setToggleActions] = useState(true);
    const [isDownloading, setIsDownloading] = useState(false);
    const [markingCompleteId, setMarkingCompleteId] = useState(null);
    const searchInputRef = useRef(null);
    const requestOpenModal = (requestId) => {
        setRequestModalOpen(true);
        setRequestId(requestId);
    };
    const requestCloseModal = (requestId) => {
        setRequestModalOpen(false);
        setRequestId(null);
    };
    const confirmOpenModal = (requestId, requestedDate = null) => {
        setConfirmModalIsOpen(true);
        setRequestId(requestId);
        setRequestedAppointmentDate(requestedDate);
    };

    const confirmModalClose = () => {
        setConfirmModalIsOpen(false);
        setRequestId(null);
        setRequestedAppointmentDate(null);
    };

    const submitConfirmModal = (dateKey, slotId, slot) => {
        if (!requestId) {
            return;
        }

        return confirmRequest(requestId, dateKey, slotId, slot)
            .then(() => toast.success('Confirm Request Successful'))
            .catch(() => toast.error('Confirm Request Failed, please try again'));
    };

    const cancelOpenModal = (requestId) => {
        setCancelModalIsOpen(true);
        setRequestId(requestId);
    };

    const cancelCloseModal = () => {
        setCancelModalIsOpen(false);
    };

    const submitCancelModal = (reason, remarks) => {
        if (!requestId || !reason) {
            return toast.error('Please select a reason to continue');
        }
        return cancelRequest(requestId, reason, remarks)
            .then(() => {
                toast.success('Cancel request successful');
            })
            .catch((error) => {
                // The error message will come from the API response
                const errorMessage = error?.message ||
                    error?.response?.data?.errorMessage ||
                    'Cancel request failed, please try again';
                toast.error(errorMessage);
            });
    };

    const openClaimRequestButton = (requestId) => {
        setShowClaimModal(true);
        setClaimRequestId(requestId);
    };

    const closeClaimRequestButton = () => {
        setShowClaimModal(false);
        setClaimRequestId(null);
    };

    const openEditPaymentButton = (requestId) => {
        setShowEditPayment(true);
        setEditPaymentRequestId(requestId);
    };

    const closeEditPaymentButton = () => {
        setShowEditPayment(false);
        setEditPaymentRequestId(null);
    };

    const openShiftRequestButton = (requestId) => {
        setShowShiftRequest(true);
        setShiftRequestId(requestId);
    };

    const closeShiftRequestButton = () => {
        setShowShiftRequest(false);
        setShiftRequestId(null);
    };

    const setAckButtonConfirmModal = (requestId) => {
        setCallAlertData({
            isOpen: true,
            header: 'Call User?',
            body: 'Are you sure you want to call user?',
            requestId,
            onSubmit: () => { },
            onClose: () => {
                setCallAlertData(defaultCallAlertData);
            },
        });
    };

    const openRequestCommentModal = (requestId) => {
        setShowCommentModal(true);
        setCommentModalRequestId(requestId);
    };

    const closeRequestCommentModal = () => {
        setShowCommentModal(false);
        setCommentModalRequestId(null);
    };

    const toggleActionsColumn = () => {
        setToggleActions((prevState) => !prevState);
    };

    const openUploadPrescriptionModal = (requestId) => {
        setShowUploadPrescriptionModal(true);
        setUploadPrescriptionRequestId(requestId);
    };

    const openRescheduleModal = (requestId) => {
        setShowRescheduleModal(true);
        setRescheduleRequestId(requestId);
    };

    const closeRescheduleModal = () => {
        setShowRescheduleModal(false);
        setRescheduleRequestId(null);
    };

    const closeUploadPrescriptionModal = () => {
        setShowUploadPrescriptionModal(false);
        setUploadPrescriptionRequestId(null);
    };

    const handleMarkConsultationCompleted = (requestId) => {
        if (!requestId) {
            return toast.error('Invalid request ID');
        }
        if (markingCompleteId === requestId) {
            return; // Already in-flight
        }

        setMarkingCompleteId(requestId);
        return markConsultationCompleted(requestId)
            .then(() => {
                toast.success('Consultation marked as completed successfully');
                fetchTableData();
            })
            .catch((error) => {
                // Differentiate error types for better UX
                const status = error?.response?.status;
                const errorCode = error?.response?.data?.errorCode;
                const errorMessage = error?.response?.data?.errorMessage || error?.message;

                if (status === 401) {
                    toast.error('Session expired. Please log in again.');
                } else if (status === 403) {
                    toast.error('You do not have permission to mark consultations as completed.');
                } else if (status === 400) {
                    // Business validation error from backend
                    toast.error(errorMessage || 'Cannot mark consultation as completed. Please check the request status and appointment date.');
                } else if (status === 500 && errorCode === 'activity_logging_failed') {
                    toast.error('Consultation marked but activity logging failed. Please contact support.');
                } else if (status >= 500) {
                    toast.error('Server error. Please try again later.');
                } else {
                    toast.error(errorMessage || 'Failed to mark consultation as completed, please try again');
                }
            })
            .finally(() => {
                setMarkingCompleteId(null);
            });
    };

    const downloadReport = useCallback(() => {
        setIsDownloading(true);

        const dateCheck = (date) => {
            return !date ? date : moment(date).format('YYYY-MM-DD');
        };

        // Build params with all current filters
        const params = {
            requestId: requestIdFilter,
            statusFilter,
            search: makeSearch,
            appointmentDateFilterStartDate: dateCheck(appointmentDateFilter),
            appointmentDateFilterEndDate: dateCheck(appointmentDateFilter),
            requestDateFilterStartDate: dateCheck(requestDateFilter),
            requestDateFilterEndDate: dateCheck(requestDateFilter),
            acknowledgementCallFilter: ackFilter,
            networkCenterFilter: vaccinationFilter,
            centerFilter: centerFilter,
            sponsorFilter: sponsorFilter,
            visitTypeFilter: visitTypeFilter,
            stageFilter: stageFilter,
            tagsFilter: tagsFilter,
        };

        // Remove empty/null params
        Object.keys(params).forEach((key) => {
            if (params[key] === null || params[key] === undefined || params[key] === '') {
                delete params[key];
            }
        });

        return downloadCsvReport(params)
            .then((blob) => {
                setIsDownloading(false);
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `physio-ops-report-${moment().format('YYYY-MM-DD')}.csv`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(downloadUrl);
                toast.success('CSV downloaded successfully');
            })
            .catch((error) => {
                setIsDownloading(false);
                console.error('Error downloading CSV:', error);
                toast.error('Failed to download CSV');
            });
    }, [
        requestIdFilter,
        statusFilter,
        makeSearch,
        appointmentDateFilter,
        requestDateFilter,
        ackFilter,
        centerFilter,
        vaccinationFilter,
        sponsorFilter,
        visitTypeFilter,
        stageFilter,
        tagsFilter,
    ]);

    const fetchTableData = (
        currPage,
        currPageSize,
        orderBy,
        orderDir,
        claimFilter
    ) => {
        const valid = (value) => typeof value === 'number';
        const dateCheck = (date) => {
            return !date ? date : moment(date).format('YYYY-MM-DD');
        };
        setIsLoading(true);
        const params = {
            draw: valid(currPageSize) ? currPageSize : pageSize,
            page: valid(currPage) ? currPage : currentPage,
            requestId: requestIdFilter,
            parentBookingID: parentIdFilter,
            statusFilter,
            search: makeSearch,
            appointmentDateFilterStartDate: dateCheck(appointmentDateFilter),
            appointmentDateFilterEndDate: dateCheck(appointmentDateFilter),
            requestDateFilterStartDate: dateCheck(requestDateFilter),
            requestDateFilterEndDate: dateCheck(requestDateFilter),
            acknowledgementCallFilter: ackFilter,
            appointmentTimeFilter: appTimeFilter,
            centerFilter: centerFilter,
            vaccinationFilter: vaccinationFilter,
            sponsorFilter: sponsorFilter,
            visitTypeFilter: visitTypeFilter,
            stageFilter: stageFilter,
            tagsFilter: tagsFilter,
        };
        if (orderBy && orderDir) {
            params.orderBy = orderBy;
            params.orderDir = orderDir;
        }
        if (claimFilter) {
            params.claimedByFilter = claimFilter;
        }
        return getAllCashlessPhysiotherapyRequests(params).then((responseBody) => {
            setIsLoading(false);
            setData(responseBody.result);
            setTotalRecords(responseBody.totalHits || 0);
            setPages(
                Math.ceil(
                    responseBody.totalHits /
                    (valid(currPageSize) ? currPageSize : pageSize)
                )
            );
        });
    };

    const onFetchData = (state) => {
        let orderBy, orderDir, claimFilter;
        if (state.sorted.length) {
            orderBy = state.sorted[0].id;
            orderDir = state.sorted[0].desc ? 'DESC' : 'ASC';
        }
        state.filtered.forEach((f) => {
            if (f.id === 'opsUserName') {
                claimFilter = f.value;
            }
        });
        fetchTableData(state.page, state.pageSize, orderBy, orderDir, claimFilter);
        setCurrentPage(state.page);
        setPageSize(state.pageSize);
    };

    useEffect(() => {
        if (deeplinkRequestId) {
            dispatch(showPhysiotherapyRequestModal(deeplinkRequestId));
        }
    }, [deeplinkRequestId]);

    useAfterInitialEffect(() => {
        fetchTableData();
    }, [
        requestIdFilter,
        parentIdFilter,
        statusFilter,
        appointmentDateFilter,
        requestDateFilter,
        ackFilter,
        makeSearch,
        appTimeFilter,
        centerFilter,
        vaccinationFilter,
        sponsorFilter,
        visitTypeFilter,
        stageFilter,
        tagsFilter,
    ]);

    const handleSearchBar = (event) => {
        const { value } = event.target;
        if (event.key === 'Enter') {
            setMakeSearch(value);
        }
    };

    const cashlessPhysiotherapyTableColumns = useTableColumns(
        {
            dispatch,
            showPhysiotherapyRequestModal,
            setRequestIdFilter,
            setParentIdFilter,
            setStatusFilter,
            confirmOpenModal,
            cancelOpenModal,
            setRequestDateFilter,
            setAppTimeFilter,
            setAppointmentDateFilter,
            setAckButtonConfirmModal,
            setAckFilter,
            openClaimRequestButton,
            openEditPaymentButton,
            openRequestCommentModal,
            openShiftRequestButton,
            setRequestCenterFilter,
            setRequestPhysiotherapyFilter,
            setRequestSponsorFilter,
            setVisitTypeFilter,
            setStageFilter,
            openUploadPrescriptionModal,
            openRescheduleModal,
            setTagsFilter,
            onMarkConsultationCompleted: handleMarkConsultationCompleted,
        },
        {
            statusFilter,
            visitTypeFilter,
            stageFilter,
            ackFilter,
            toggleActions,
            tagsFilter,
            markingCompleteId,
        },
        [statusFilter, visitTypeFilter, stageFilter, ackFilter, toggleActions, tagsFilter, markingCompleteId]
    );
    // const myHeaders = new Headers();
    // myHeaders.append("Authorization", "JWT eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjI5MCwicGxhdGZvcm0iOiJXRUIiLCJ1c2VyVHlwZSI6Im9wcyIsImlhdCI6MTcyMTM2ODIxNywiZXhwIjoxNzIxNDU0NjE3fQ.hMbqfiaIjw7tt27mXDTnnekfl49WfSmbzmEUAQh2YbU");

    // const requestOptions = {
    //   method: "GET",
    //   headers: myHeaders,
    //   redirect: "follow"
    // };

    // fetch("https://api.samuraijack.xyz/v3/physio/ops/requests", requestOptions)
    //   .then((response) => response.text())
    //   .then((result) => console.log(result))
    //   .catch((error) => console.error(error));
    // console.log("These are the state details: ",stateDetails);
    return (
        <OuterComponent>
            <NavBar />
            <PaddedContainer className="pt-4 mt-5">
                <Row>
                    <div className="col">
                        <div className="row">
                            <div className="col-8">
                                <SearchBox>
                                    <SearchBoxInput
                                        ref={searchInputRef}
                                        placeholder="Search..."
                                        type="text"
                                        onKeyDown={handleSearchBar}
                                    />
                                    <SearchBoxContent>{totalRecords} records</SearchBoxContent>
                                </SearchBox>
                            </div>
                            <div className="col-1">
                                {isLoading ? (
                                    <LoadingComponent />
                                ) : (
                                    <button
                                        onClick={() => setMakeSearch(searchInputRef.current.value)}
                                        className="btn btn-primary"
                                    >
                                        <FaSearch />
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-2">
                        <ButtonGroup size="sm">
                            <Button onClick={downloadReport} disabled={isDownloading || totalRecords === 0}>
                                {isDownloading ? 'Downloading...' : 'Download CSV'}
                            </Button>
                        </ButtonGroup>
                    </div>
                </Row>
            </PaddedContainer>
            <ReactTable
                data={data}
                columns={cashlessPhysiotherapyTableColumns}
                loading={isLoading}
                filterable
                manual
                pages={pages}
                showPaginationTop
                className="-striped -highlight"
                onFetchData={onFetchData}
                pageSizeOptions={[2, 5, 20, 50, 100, 200, 500]}
                defaultSorted={[
                    {
                        id: 'requestId',
                        desc: true,
                    },
                ]}
                SubComponent={(row) => (
                    <SubContainer
                        requestId={row.original.requestId}
                        userId={row.original.userId}
                    />
                )}
            />

            {/* for confirming vaccination appointment */}
            <PhysiotherapyModalConfirm
                modalIsOpen={confirmModalIsOpen}
                openModal={confirmOpenModal}
                closeModal={confirmModalClose}
                submitModal={submitConfirmModal}
                onComplete={fetchTableData}
                requestId={requestId}
                requestedAppointmentDate={requestedAppointmentDate}
            />

            <PhysiotherapyModalCancel
                modalIsOpen={cancelModalIsOpen}
                openModal={cancelOpenModal}
                closeModal={cancelCloseModal}
                submitModal={submitCancelModal}
                onComplete={fetchTableData}
                requestId={requestId}
            />

            {/* for calling the patient */}
            <PhysiotherapyCallModal {...callAlertData} onComplete={fetchTableData} />

            {stateDetails?.requestId ? (
                <PhysiotherapyRequestDetails
                    details={stateDetails}
                    onClose={() => {
                        dispatch(hidePhysiotherapyRequestModal());
                        history.replace('/cashless-physiotherapy-v2');
                    }}
                    isOpen={stateDetails && stateDetails.requestId}
                />
            ) : (
                <></>
            )}
            {/* <PhysiotherapyRequestDetails 
            details={stateDetails}
            onClose={() => dispatch(hidePhysiotherapyRequestModal())}
            isOpen={stateDetails && stateDetails.requestId}
            
        /> */}

            <PhysiotherapyClaimModal
                requestId={claimRequestId}
                isOpen={showClaimModal}
                onClose={closeClaimRequestButton}
                onComplete={fetchTableData}
            />

            <PhysiotherapyCommentModal
                requestId={commentModalRequestId}
                isOpen={showCommentModal}
                onComplete={fetchTableData}
                onClose={closeRequestCommentModal}
            />

            <PhysiotherapyShiftRequestModal
                requestId={shiftRequestId}
                isOpen={showShiftRequest}
                onComplete={fetchTableData}
                onClose={closeShiftRequestButton}
            />

            <PhysiotherapyUploadPrescriptionModal
                isOpen={showUploadPrescriptionModal}
                toggle={closeUploadPrescriptionModal}
                requestId={uploadPrescriptionRequestId}
                onUploadComplete={fetchTableData}
            />

            <PhysiotherapyRescheduleModal
                isOpen={showRescheduleModal}
                toggle={closeRescheduleModal}
                requestId={rescheduleRequestId}
                onComplete={fetchTableData}
            />
        </OuterComponent>
    );
};

const matchStateToProps = (state) => ({
    cashlessPhysiotherapy: state.cashlessPhysiotherapy,
});

export default connect(matchStateToProps)(CashlessPhysiotherapyV2);
